import React from 'react';
import { Typography } from '@material-ui/core';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  setEdited,
  setEditedRoutineDays,
} from '../../redux/actions/routineDaysActions';
import WeekDays from './WeekDays';
interface WDSIProps {
  title?: string;
  targetName: string;
  targetReducer: string;
  hasEditPermission: boolean
}

export default function ToggleButtonsMultiple({
  targetReducer,
  targetName,
  title,
  hasEditPermission
}: WDSIProps) {
  const dispatch: any = useDispatch();

  const weekDays: any = useSelector<string[]>(
    (state: RootStateOrAny) => state[targetReducer][targetName],
  );
  const handleFormat = (
    event: React.MouseEvent<HTMLElement>,
    newFormats: string[],
  ) => {
    if (newFormats.length >= 1) {
      dispatch(setEditedRoutineDays(newFormats));
      dispatch(setEdited(true));
    }
  };

  return (
    <>
      <Typography>{title}</Typography>
      <WeekDays weekDays={weekDays} handleFormat={handleFormat} hasEditPermission={hasEditPermission} />
    </>
  );
}
